import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";
import { Box, Grid, Typography } from "@mui/material";
import { MdUploadFile, MdPhotoCamera, MdCancel } from "react-icons/md";
import { BsQuestionCircle } from "react-icons/bs";

import Tooltip from "../pages/cpr/Tooltip";
import CameraComponent from "../CameraComponent";
import * as CONST from "../Constants";
import { useStyles } from "./Styles";

const propTypes = {
  setAttachment: PropTypes.func.isRequired,
};

UploadFile.prototype = propTypes;

export default function UploadFile(props) {
  const styles = useStyles();
  const [uploaded, setUploaded] = useState(null);
  const [showCamera, setShowCamera] = useState(null);

  const handleClick = useCallback((event) => {
    setShowCamera(true);
  });

  const onDrop = useCallback((v) => {
    let file = v instanceof Array ? v[0] : v;
    props.setAttachment(file);
    setUploaded(file);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <>
      <Grid item xs={12} mb={2}>
        <Typography color="#1a247e" fontWeight="600" mb={1} variant="h5">
          {CONST.DATE_PROVIDER_PROMPTS.DOCUMENT}
        </Typography>

        <Tooltip
          content={
            <Box>
              <Typography fontWeight={600} variant="body1" mb={1} color="#1a247e">
                {CONST.TOOLTIP.DOCUMENT_UPLOAD_TITLE}
              </Typography>
              <ul>
                {CONST.TOOLTIP.DOCUMENT_UPLOAD_EXAMPLES.map((i) => (
                  <li key={i}>{i}</li>
                ))}
              </ul>
            </Box>
          }
          tooltip={
            <Typography variant="body1" mb={2}>
              <i>{CONST.TOOLTIP.DOCUMENT_UPLOAD}</i>
              <BsQuestionCircle style={{ margin: "auto auto -3px 4px" }} />
            </Typography>
          }
        />
      </Grid>

      {!uploaded && !showCamera && (
        <Grid container mt={1} mb={4} spacing={1}>
          <Grid item xs={6}>
            <Box className="upload-file-camera" {...getRootProps()}>
              <MdUploadFile className={styles.btnIcon} />
              <input {...getInputProps()} />
              Upload File
            </Box>
          </Grid>
        </Grid>
      )}

      {showCamera && (
        <Grid container>
          <Grid item xs={12} mb={1}>
            <button onClick={(e) => setShowCamera(false)} className="prompt secondary">
              {"Back to upload options"}
            </button>
          </Grid>

          <CameraComponent
            setAttachment={(v) => {
              setShowCamera(false);
              onDrop(v);
            }}
          />
        </Grid>
      )}

      {uploaded && (
        <Grid item xs={12} my={1} display="inline-flex" alignItems="center">
          <MdUploadFile
            className={styles.btnIcon}
            style={{ color: "#2cb5fa", padding: "0px", marginBottom: "0px" }}
          />
          <Box sx={{ border: "dashed 0.12em #e8e8e8", borderRadius: "4px", p: "4px 16px" }}>
            {uploaded.name}
          </Box>
          <MdCancel
            className={styles.cancelBtnIconSmall}
            onClick={() => {
              props.setAttachment(null);
              setUploaded(false);
              setShowCamera(false);
            }}
          />
        </Grid>
      )}
    </>
  );
}
